import api from "../../utils/apiCliente";

export const getPerfilCliente = async () => {
  const res = await api.get("/api/cliente/checkout/perfil");
  return res.data;
};

export const getDireccionesCliente = async () => {
  const res = await api.get("/api/cliente/checkout/direcciones");
  return res.data;
};
